// https://firebase.google.com/docs/firestore/quickstart?hl=es-419#web-version-9
// https://stackoverflow.com/questions/58246333/how-to-initialize-firebase-in-gatsby
// https://stackoverflow.com/questions/68692470/firebase-v9-loads-a-large-iframe-js-263k-on-mobile
// https://github.com/firebase/firebase-js-sdk/issues/4946#issuecomment-921147692

// import firebase from 'firebase/compat/app'
// import 'firebase/compat/auth';
// import 'firebase/compat/firestore'
import { initializeApp } from 'firebase/app';
import {
	Auth,
	browserLocalPersistence,
	browserPopupRedirectResolver,
	browserSessionPersistence,
	inMemoryPersistence,
	indexedDBLocalPersistence,
	initializeAuth,
} from 'firebase/auth';
// import {initializeAuth,  indexedDBLocalPersistence, getAuth} from "firebase/auth";
// import { getFirestore } from "firebase/firestore/lite";

const firebaseConfig = {
	apiKey: process.env.GATSBY_APIKEY_FIREBASE,
	authDomain: process.env.GATSBY_AUTHDOMAIN,
	projectId: process.env.GATSBY_PROJECTID,
	storageBucket: process.env.GATSBY_STORAGEBUCKET,
	messagingSenderId: process.env.GATSBY_MESSAGINGSENDERID,
	appId: process.env.GATSBY_APPID,
	measurementId: process.env.GATSBY_MEASUREMENTID,
};

// const useFirebase = () => {
//   // console.log('APIKEY_FIREBASE',process.env.GATSBY_APIKEY_FIREBASE)
//     const app = initializeApp({
//       apiKey: process.env.GATSBY_APIKEY_FIREBASE,
//       authDomain: process.env.GATSBY_AUTHDOMAIN,
//       projectId: process.env.GATSBY_PROJECTID,
//       storageBucket: process.env.GATSBY_STORAGEBUCKET,
//       messagingSenderId: process.env.GATSBY_MESSAGINGSENDERID,
//       appId: process.env.GATSBY_APPID,
//       measurementId: process.env.GATSBY_MEASUREMENTID
//     })

//     const auth = initializeAuth(app, {
//       persistence: [indexedDBLocalPersistence],
//     });

//     const firestore = getFirestore();

//     const firebase = {
//       app,
//       auth,
//       firestore
//     }

//   return firebase
// }

export const FirebaseApp = initializeApp(firebaseConfig);
// export const FirebaseAuth = getAuth(FirebaseApp)

/*
  https://github.com/angular/angularfire/issues/3181
  * This is a hack to get around the issue described in this thread:
  * https://github.com/firebase/firebase-js-sdk/issues/5475
  *
  * It has not been fixed and the webpack trick both did not work nor
  * was it simple to implement. What this does is it checks to see if it
  * is being SSR'd, if it is not then initialize firebase normally,
  * if it is then just "gets" the auth, which is essential a noop.
  */

export let FirebaseAuth: any = null;

if (typeof window === 'undefined') {
	// is ssr
	FirebaseAuth = initializeAuth(FirebaseApp, {
		persistence: browserLocalPersistence,
	});
} else {
	FirebaseAuth = initializeAuth(FirebaseApp, {
		persistence: browserLocalPersistence,
		popupRedirectResolver: browserPopupRedirectResolver,
	});
}

// export const FirebaseAuth = initializeAuth(FirebaseApp, {
//   popupRedirectResolver: browserPopupRedirectResolver,

//   persistence: [
//     indexedDBLocalPersistence,
//     browserLocalPersistence,
//     browserSessionPersistence,
//   ],
// });

// export const FirebaseDB = getFirestore(FirebaseApp)
